var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: {
        inline: false,
        model: _vm.specialProponentJudgment,
        "label-width": "190px",
        "label-position": "right"
      }
    },
    [
      _vm.showFrοmBoard
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Αποφάσεις Μελών Επιτροπής:" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.boardJudgement }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Όνομα", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.firstname))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Επώνυμο", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.surname))])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: { label: "Αποδοχή πρότασης", align: "center" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Εισηγητή",
                              width: "90",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.agreeWithProponent === true
                                      ? _c(
                                          "span",
                                          { staticClass: "agree-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-check"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.agreeWithProponent === false
                                      ? _c(
                                          "span",
                                          { staticClass: "disagree-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-close"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.agreeWithProponent === null
                                      ? _c(
                                          "span",
                                          { staticClass: "pending-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-minus"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _vm.fromConsultant
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "Ακαδημαικού Συμβούλου",
                                  width: "110",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.agreeWithAC === true
                                          ? _c(
                                              "span",
                                              { staticClass: "agree-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.agreeWithAC === false
                                          ? _c(
                                              "span",
                                              { staticClass: "disagree-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-close"
                                                }),
                                                _vm._v(" "),
                                                scope.row.agreeWithAC === null
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pending-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-minus"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Εισήγηση" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.proposal))])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Υποβολή",
                          width: "85",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.finalize === true
                                  ? _c("span", { staticClass: "done-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.finalize === false
                                  ? _c("span", { staticClass: "pending-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showFromAC
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Aκαδημαϊκός σύμβουλος:" } },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.consultantName) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Εισήγηση Ακαδημαϊκού:" } },
                        [
                          _vm._v(
                            "\n         " +
                              _vm._s(_vm.consultantJudgement) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFromPresident
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Ακαδ. περιοχή", size: "small" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.application.applicationHistory
                          .slice(0)
                          .reverse()
                          .find(function(step) {
                            return (
                              step.applicationStatus === "presidentW_Prechecker"
                            )
                          }).judgment.academicField.name
                      ) +
                      "\n    "
                  )
                ]
              ),
              _c("br")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFromPrechecker
        ? _c(
            "div",
            [
              !_vm.isReappraisal && !_vm.isPostExam
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ακαδ. περιοχή", size: "small" } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.application.applicationHistory
                              .slice(0)
                              .reverse()
                              .find(function(step) {
                                return step.applicationStatus === "precheckerW_"
                              }).judgment.academicField.name
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _c("br"),
              _vm._v(" "),
              _vm.isReappraisal || _vm.isPostExam
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ακαδ. περιοχή", size: "small" } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            this.workingApplication.relevantAppl.academicField
                              .name
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && this.workingApplication.overdue
        ? _c(
            "el-form-item",
            [
              _c("el-alert", {
                staticStyle: {
                  border: "1px solid",
                  "background-color": "#fdf6ec"
                },
                attrs: {
                  closable: false,
                  type: "warning",
                  title: _vm.OVERDUE_MESSAGE,
                  "show-icon": ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && this.workingApplication.overdue
        ? _c("br")
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeLabel() }
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Παρακαλώ εισάγετε βαθμό",
                  maxlength: "4"
                },
                model: {
                  value: _vm.application.grade,
                  callback: function($$v) {
                    _vm.$set(_vm.application, "grade", $$v)
                  },
                  expression: "application.grade"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal && _vm.application.grade_description
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeDescriptionLabel() }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.application.grade_description) + "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal ? _c("hr") : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal && !_vm.isPostExam
        ? _c("table", [
            _c("tr", [
              _c("th", [_vm._v("Τίτλος προς αναγνώριση")]),
              _vm._v(" "),
              _vm.application.titles.titleConsideration
                ? _c("th", [_vm._v("Συνυποβαλλόμενος τίτλος")])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Πανεπιστήμιο", size: "small" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.application.titles.university.name) +
                          "\n          "
                      ),
                      _vm.uniAccredited.show
                        ? _c("el-alert", {
                            attrs: {
                              closable: false,
                              title: _vm.uniAccredited.title,
                              type: _vm.uniAccredited.type,
                              "show-icon": ""
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.omotages.university &&
                  _vm.omotages.university[0].exName !== null &&
                  _vm.omotages.university[0].exName !== ""
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Πρώην ονομασία: ", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.omotages.university[0].exName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.omotages.university &&
                  _vm.omotages.university[0].comments !== null &&
                  _vm.omotages.university[0].comments !== ""
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Παρατηρήσεις: ", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.omotages.university[0].exName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.omotages.college && _vm.omotages.college.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Κολέγιο", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.application.titles.college.name) +
                              "\n          "
                          ),
                          _vm.colAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.colAccredited.title,
                                  type: _vm.colAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.omotages.faculty && _vm.omotages.faculty.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Σχολή", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.application.titles.faculty.name) +
                              "\n          "
                          ),
                          _vm.facAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.facAccredited.title,
                                  type: _vm.facAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.omotages.department && _vm.omotages.department.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Τμήμα", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.application.titles.department.name) +
                              "\n          "
                          ),
                          _vm.depAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.depAccredited.title,
                                  type: _vm.depAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.application.titles.titleConsideration
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Πανεπιστήμιο", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.application.titles.titleConsideration
                                  .university.name
                              ) +
                              "\n          "
                          ),
                          _vm.conUniAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.conUniAccredited.title,
                                  type: _vm.conUniAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.application.titles.titleConsideration &&
                  _vm.omotagesConsideration.college &&
                  _vm.omotagesConsideration.college.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Κολέγιο", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.application.titles.titleConsideration
                                  .college.name
                              ) +
                              "\n          "
                          ),
                          _vm.conColAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.conColAccredited.title,
                                  type: _vm.conColAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.application.titles.titleConsideration &&
                  _vm.omotagesConsideration.faculty &&
                  _vm.omotagesConsideration.faculty.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Σχολή", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.application.titles.titleConsideration
                                  .faculty.name
                              ) +
                              "\n          "
                          ),
                          _vm.conFacAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.conFacAccredited.title,
                                  type: _vm.conFacAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.application.titles.titleConsideration &&
                  _vm.omotagesConsideration.department &&
                  _vm.omotagesConsideration.department.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Τμήμα", size: "small" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.application.titles.titleConsideration
                                  .department.name
                              ) +
                              "\n          "
                          ),
                          _vm.conDepAccredited.show
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  title: _vm.conDepAccredited.title,
                                  type: _vm.conDepAccredited.type,
                                  "show-icon": ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("proposals"),
          _vm._v(" "),
          _c("internalComments"),
          _vm._v(" "),
          _c("hr")
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isReappraisal && !_vm.isPostExam
        ? _c(
            "div",
            [
              this.application.titles.college != null &&
              this.application.titles.faculty != null &&
              this.application.titles.department != null
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Παλιότερη πράξη", size: "small" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            icon: "el-icon-search",
                            disabled: !_vm.isActiveBtn
                          },
                          on: {
                            click: function($event) {
                              _vm.getEquivalentActs()
                              _vm.showSelectActs = true
                            }
                          }
                        },
                        [_vm._v("\n        Αναζήτηση\n      ")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              typeof this.application.attachedDocuments
                .slice(0)
                .find(function(step) {
                  return step.type === 19
                }) !== "undefined"
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          title:
                            "Βρέθηκε σχετική πράξη παλιότερης αναγνώρισης και είναι συνημμένη στην καρτέλα Επισυναπτόμενα",
                          closable: "false",
                          type: "success",
                          "show-icon": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedActFound === true
                ? _c(
                    "div",
                    [
                      _c("el-form-item", [
                        _c("span", [
                          _vm._v(
                            "Βρέθηκε παλιότερη πράξη με αριθμό: " +
                              _vm._s(this.selectedActNo) +
                              "\n        και ημερομηνία: " +
                              _vm._s(this.selectedActDate) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " σύμφωνα με την οποία: " +
                              _vm._s(this.selectedActDecision) +
                              " ο τίτλος: " +
                              _vm._s(this.selectedActTitle)
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Ανέβασμα πράξης" } },
                    [
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: this.addingAct,
                              expression: "this.addingAct"
                            }
                          ],
                          ref: "uploadSimilarAct",
                          staticClass: "upload-demo",
                          attrs: {
                            disabled: !_vm.isActiveBtn,
                            accept: ".pdf, .doc",
                            "file-list": _vm.attachedSimilarAct,
                            "http-request": _vm.addSimilarAct,
                            action: "",
                            "on-remove": _vm.removeAct,
                            limit: 1,
                            "auto-upload": true,
                            "show-file-list": true
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                                disabled: !_vm.isActiveBtn
                              },
                              slot: "trigger"
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-upload el-icon-right"
                              }),
                              _vm._v(" Ανέβασμα")
                            ]
                          ),
                          _vm._v(" "),
                          _vm.attachedSimilarAct.length === 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [
                                  _vm._v(
                                    "** Μ Ο Ν Ο για να ανεβάσετε ένα αρχείο παλαιότερης όμοιας πράξης (pdf έως 12MB)"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-dialog",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingEquivalentActs,
                              expression: "loadingEquivalentActs"
                            }
                          ],
                          attrs: {
                            title: "Παρόμοιες πράξεις",
                            visible: _vm.showSelectActs,
                            width: "90%"
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.showSelectActs = $event
                            }
                          }
                        },
                        [
                          !_vm.foundEquivalentActs
                            ? _c("span", [
                                _vm._v("Δε βρέθηκαν παλιότερες πράξεις")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.foundEquivalentActs
                            ? _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.praxeis,
                                    "max-height": "350"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Αρ. πράξης",
                                      width: "120"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.PraxeisNo)
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Ημ/νια πράξης",
                                      width: "120"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.PraxeisDate.substring(
                                                    0,
                                                    10
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "Τίτλος", width: "200" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.certificationTitle
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "Απόφαση" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(scope.row.decision))
                                            ])
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "Επιλογή", width: "180" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  label: scope.row.PraxeisNo
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.selectedActChanged(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.selectedAct,
                                                  callback: function($$v) {
                                                    _vm.selectedAct = $$v
                                                  },
                                                  expression: "selectedAct"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Επιλογή\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.showSelectActs = false
                                    }
                                  }
                                },
                                [_vm._v("Άκυρο")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.foundEquivalentActs
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showSelectActs = false
                                      _vm.selectedEquivalentAct(
                                        _vm.selectedActId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Επιλογή\n            ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Κατηγορία αίτησης" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-text": "Νομικό ζήτημα",
                  "inactive-text": "Ακαδημαϊκό ζήτημα",
                  disabled: _vm.fromReappraisalBoard
                },
                model: {
                  value: _vm.specialProponentJudgment.legalIssue,
                  callback: function($$v) {
                    _vm.$set(_vm.specialProponentJudgment, "legalIssue", $$v)
                  },
                  expression: "specialProponentJudgment.legalIssue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Ενημ. σημείωμα" } },
            [
              _c("vue-editor", {
                staticClass: "propcolor",
                attrs: { "editor-toolbar": _vm.customToolbar },
                model: {
                  value: _vm.specialProponentJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.specialProponentJudgment, "proposal", $$v)
                  },
                  expression: "specialProponentJudgment.proposal"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPostExam
        ? _c(
            "el-form-item",
            { attrs: { label: "Υπολογισμός Τελικού Βαθμού" } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploadingFinalGrade,
                      expression: "this.uploadingFinalGrade"
                    }
                  ],
                  ref: "uploadFinalGradeRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.finalGradeAttachments,
                    "http-request": _vm.addFinalGradeAttachment,
                    "on-remove": _vm.handleFinalGradeRemove,
                    "before-remove": _vm.handleBeforeRemove,
                    "on-preview": _vm.viewPdf,
                    action: "",
                    limit: 1,
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                        disabled: _vm.finalGradeAttachments.length >= 1
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα εγγράφου Υπολογισμού Τελικού Βαθμού (pdf έως 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Δικαιολογητικό" } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploadingAdditional,
                      expression: "this.uploadingAdditional"
                    }
                  ],
                  ref: "uploadProponentRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.proponentAttachments,
                    "http-request": _vm.addAdditionalAttachment,
                    "on-remove": _vm.handleAdditionalRemove,
                    "before-remove": _vm.handleBeforeRemove,
                    "on-preview": _vm.viewPdf,
                    action: "",
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary"
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα επιπλέον δικαιολογητικού της αίτησης (pdf έως 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Επισκόπηση Επανεξέτασης" } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploadingReappraisalOverview,
                      expression: "this.uploadingReappraisalOverview"
                    }
                  ],
                  ref: "uploadReappraisalOverviewRef",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.reappraisalOverviewAttachments,
                    "http-request": _vm.addReappraisalOverviewAttachment,
                    "on-remove": _vm.handleReappraisalOverviewRemove,
                    "before-remove": _vm.handleBeforeRemove,
                    "on-preview": _vm.viewPdf,
                    limit: 1,
                    action: "",
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                        disabled: _vm.reappraisalOverviewAttachments.length >= 1
                      },
                      slot: "trigger"
                    },
                    [_vm._v("Ανέβασμα")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Επισκόπησης της αίτησης Επανεξέτασης (pdf έως 12MB)"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Εσωτερικό Σχόλιο" } },
            [
              _c("el-input", {
                staticClass: "internalComment",
                attrs: {
                  type: "textarea",
                  placeholder: "Εισάγετε εσωτερικό σχόλιο",
                  size: "100",
                  autosize: { minRows: 4, maxRows: 10 }
                },
                on: { change: _vm.modifyInternalComment },
                model: {
                  value: _vm.specialProponentJudgment.internalComment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.specialProponentJudgment,
                      "internalComment",
                      $$v
                    )
                  },
                  expression: "specialProponentJudgment.internalComment"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard && !_vm.isPostExam
        ? _c(
            "el-form-item",
            { attrs: { label: "Σχόλιο για Πολίτη" } },
            [
              _c("el-input", {
                staticClass: "citizenComment",
                attrs: {
                  type: "textarea",
                  placeholder: "Εισάγετε σχόλιο για Πολίτη",
                  size: "100",
                  autosize: { minRows: 4, maxRows: 10 }
                },
                on: { change: _vm.modifyPendingReason },
                model: {
                  value: _vm.specialProponentJudgment.pendingReason,
                  callback: function($$v) {
                    _vm.$set(_vm.specialProponentJudgment, "pendingReason", $$v)
                  },
                  expression: "specialProponentJudgment.pendingReason"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rerouteExists
        ? _c(
            "el-form-item",
            { attrs: { label: "Σχόλιο Αναδρομολόγησης" } },
            [
              _c("el-input", {
                staticClass: "rerouteComment",
                attrs: {
                  type: "textarea",
                  placeholder: "Εισάγετε σχόλιο για Πολίτη",
                  size: "100",
                  disabled: true,
                  autosize: { minRows: 4, maxRows: 10 }
                },
                model: {
                  value: _vm.rerouteCom,
                  callback: function($$v) {
                    _vm.rerouteCom = $$v
                  },
                  expression: "rerouteCom"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Στην Αναμονή" } },
            [
              _c("el-checkbox", {
                attrs: { label: "Ναι", border: "" },
                on: { change: _vm.toggleQueue },
                model: {
                  value: _vm.specialProponentJudgment.queue,
                  callback: function($$v) {
                    _vm.$set(_vm.specialProponentJudgment, "queue", $$v)
                  },
                  expression: "specialProponentJudgment.queue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            { attrs: { label: "Χρώμα" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Εισάγετε χρώμα" },
                model: {
                  value: _vm.specialProponentJudgment.color,
                  callback: function($$v) {
                    _vm.$set(_vm.specialProponentJudgment, "color", $$v)
                  },
                  expression: "specialProponentJudgment.color"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingRoleMembers
        ? _c(
            "el-form-item",
            { attrs: { label: "Σύμβουλος" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.specialProponentJudgment.assignedTo.uid,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.specialProponentJudgment.assignedTo,
                        "uid",
                        $$v
                      )
                    },
                    expression: "specialProponentJudgment.assignedTo.uid"
                  }
                },
                _vm._l(_vm.usersToAssign, function(user) {
                  return _c("el-option", {
                    key: user.id,
                    attrs: {
                      value: user.id,
                      label:
                        user.surname +
                        " " +
                        user.firstname.substring(0, 1) +
                        ". (" +
                        user.specialty.name +
                        ")"
                    }
                  })
                })
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard
        ? _c(
            "el-form-item",
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top" }
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      "\n          Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης πριν "
                    ),
                    _c("br"),
                    _vm._v(
                      " προχωρήσετε στην αποδέσμευσή της αλλιώς όλα τα σχόλια "
                    ),
                    _c("br"),
                    _vm._v(" που προσθέσατε θα χαθούν.\n        ")
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", {
                    attrs: { label: "Επιθυμώ να αποδεσμεύσω την αίτηση" },
                    model: {
                      value: _vm.releaseChecked,
                      callback: function($$v) {
                        _vm.releaseChecked = $$v
                      },
                      expression: "releaseChecked"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromReappraisalBoard && !_vm.isPostExam
        ? _c(
            "el-form-item",
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top" }
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      "\n          Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης "
                    ),
                    _c("br"),
                    _vm._v(" για να ανοίξει ο διάλογος\n        ")
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", {
                    attrs: { label: "Άνοιγμα διαλόγου με πολίτη" },
                    model: {
                      value: _vm.communicationActive,
                      callback: function($$v) {
                        _vm.communicationActive = $$v
                      },
                      expression: "communicationActive"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "padding-bottom": "10px" } },
        [
          !_vm.fromReappraisalBoard
            ? _c("releaseButton", {
                attrs: {
                  releaseOrReroute: "release",
                  popoverContent:
                    "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;\n        Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                  tooltipContent: "Η αίτηση θα επιστρέψει στον προέλεγχο",
                  releaseChecked: _vm.releaseChecked,
                  workingApplicationId: _vm.workingApplication.id,
                  releaseByUser: "specialProponent"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.fromReappraisalBoard
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    round: "",
                    disabled: false
                  },
                  on: { click: _vm.tempSave }
                },
                [_vm._v("\n      Προσωρινή Αποθήκευση\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: !_vm.isValidForm
              },
              on: { click: _vm.finalSave }
            },
            [_vm._v("\n      Οριστική Υποβολή\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75f2a9f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f2a9f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/SpecialProponentJudgment.vue
// module id = null
// module chunks = 